var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import T, { addTranslations } from '../../Utils/Locale';
import { getGlobalState } from '../../Utils/GlobalState';
import Button from '../../Components/ComponentButton';
import AuthenticationLoginFormLogin from './AuthenticationLoginFormLogin';
import AuthenticationLoginFormReset from './AuthenticationLoginFormReset';
import translations from './translations/authenticate-form.yml';
addTranslations(translations);
const PAGE = {
    LOGIN: 'login',
    RESET: 'reset'
};
const AuthenticationLoginForm = ({ onCreateClick, onFinish, onBack }) => {
    const [page, setPage] = useState(PAGE.LOGIN);
    const [email, setEmail] = useState();
    const [errors, setErrors] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [attempted, setAttempted] = useState(0);
    function authenticate(emailToAuthenticate, password) {
        return __awaiter(this, void 0, void 0, function* () {
            yield setLoading(true);
            setEmail(emailToAuthenticate);
            try {
                const applicationUrl = getGlobalState('application_url');
                const result = yield axios.post(`${applicationUrl}/api/user/authenticate`, { email: emailToAuthenticate, password }, { withCredentials: true });
                if (onFinish) {
                    onFinish();
                }
                else {
                    window.location.href = result.data;
                }
            }
            catch (error) {
                setErrors({ email: T('authentication.authenticate.errors.login_error') });
                setLoading(false);
                if (attempted > 2) {
                    setPage(PAGE.RESET);
                }
                else {
                    setAttempted(attempted + 1);
                }
                return false;
            }
        });
    }
    function reset(emailToReset) {
        return __awaiter(this, void 0, void 0, function* () {
            yield setLoading(true);
            try {
                const applicationUrl = getGlobalState('application_url');
                const result = yield axios.post(`${applicationUrl}/resetting/send-email`, { username: emailToReset }, { withCredentials: true });
                if (!result) {
                    setErrors({ email: T('authentication.authenticate.errors.email') });
                }
                else {
                    window.location.href = result.request.responseURL;
                }
            }
            catch (exception) {
                yield setLoading(false);
                return false;
            }
        });
    }
    return (_jsxs("div", Object.assign({ className: 'form-wrap' }, { children: [page === PAGE.LOGIN &&
                _jsx(AuthenticationLoginFormLogin, { authenticate: authenticate, errors: errors, isLoading: isLoading, goToResetPage: () => setPage(PAGE.RESET) }), page === PAGE.RESET &&
                _jsx(AuthenticationLoginFormReset, { reset: reset, errors: errors, prefilledEmail: email, onBack: () => setPage(PAGE.LOGIN), isLoading: isLoading }), _jsxs("div", Object.assign({ className: 'flex flex-col justify-center items-center mb-12 md:mb-7' }, { children: [onCreateClick && (_jsxs("span", Object.assign({ className: 'text-dark-teal self-center font-medium text-xs mb-10' }, { children: [T('authentication.authenticate.non_existing'), _jsx(Button, Object.assign({ classes: 'tailwind-reset underline ml-1 text-dark-teal self-center font-medium text-xs', onClick: onCreateClick }, { children: T('authentication.authenticate.create') }))] }))), onBack && (_jsx(Button, Object.assign({ onClick: onBack }, { children: T('authentication.create.back') })))] }))] })));
};
AuthenticationLoginForm.propTypes = {
    onCreateClick: PropTypes.func,
    onFinish: PropTypes.func,
    onBack: PropTypes.func
};
export default AuthenticationLoginForm;
